<template>
  <span>
    <Dialog 
      :header="tituloModel" 
      :visible.sync="showExportarNfsePeriodo"
      :style="{ width: '92vw', maxWidth: '1100px' }" 
      :contentStyle="{ maxHeight: '82vh', overflowY: 'auto' }" 
      :modal="true" 
      :closable="false"
    >
      <div class="container-fluid p-0">
        <div id="topo" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="dataIni">Período Inicial *</label>
              <CustomCalendar id="dataIni" name="dataIni" v-model="dataFatoGeradorIni" :showIcon="true" dateFormat="dd/mm/yy"
                placeholder="DD/MM/AAAA" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
            </span>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="dataFin">Período Final *</label>
              <CustomCalendar id="dataFin" name="dataFin" v-model="dataFatoGeradorFim" :showIcon="true" dateFormat="dd/mm/yy"
                placeholder="DD/MM/AAAA" @keyup.enter="pesquisar" v-maska="'##/##/####'" />
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="tomador">{{ origem === 'DAPS' ? 'Prestador' : 'Tomador' }}</label>
              <AutoComplete id="tomador" v-model="selectedPessoa" :dropdown="true" :suggestions="filteredPessoas"
                @complete="searchPessoa($event)" @keyup.enter="pesquisar" field="detail"
                :placeholder="placeholderPessoa" />
            </span>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="servico">Serviço</label>
              <AutoComplete id="servico" v-model="selectedServico" :dropdown="true" :suggestions="filteredServicos"
                field="detail" @complete="searchServico($event)" placeholder="Pesquisar Serviço">
                <template #item="slotProps">
                  <div class="p-fluid" style="max-width: 100%">
                    {{ slotProps.item.detail }}
                  </div>
                </template>
              </AutoComplete>
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="situacao">Situação *</label>
              <Dropdown id="situacao" v-model="filtroSituacao" :options="filtroSituacoes" optionLabel="name"
                placeholder="Selecione uma Situação" />
            </span>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <span class="p-fluid">
              <label class="font-weight-bold mb-1" for="tipo">Tipo de Exportação *</label>
              <Dropdown 
                id="tipo" 
                v-model="filtroTipo" 
                :options="tiposFiltrados" 
                optionLabel="name"
                placeholder="Selecione um Tipo" 
              />
            </span>
          </div>
        </div>
      </div>

      <Toast style="max-width: 90vw; width: 600px;" position="bottom-center" group="bc">
        <template #message="slotProps">
          <div class="flex flex-column">
            <div class="text-center">
              <i class="pi pi-info-circle" style="font-size: 3rem"></i>
              <h4 style="font-weight: bold">{{ slotProps.message.summary }}</h4>
              <p class="msg-export">{{ slotProps.message.detail }}</p>
              <p class="msg-export">
                Assim que a exportação for finalizada, você receberá um e-mail de confirmação.
              </p>
            </div>
          </div>
        </template>
      </Toast>

      <!-- Seção: Histórico de Solicitações -->
      <div class="mt-4 pt-3 border-top">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex align-items-center">
            <i class="pi pi-history mr-2 text-primary" style="font-size: 1.2rem;"></i>
            <span class="font-weight-bold text-dark mr-2" style="font-size: 1rem;">Histórico de Solicitações</span>
            <Button 
              type="button" 
              icon="pi pi-refresh" 
              class="p-button-rounded p-button-text p-button-sm" 
              title="Atualizar lista agora"
              :disabled="loading"
              @click="consultaSolicitacoes()" 
            />
          </div>
          <small class="text-muted">
            <i class="pi pi-info-circle mr-1"></i> A lista é atualizada automaticamente
          </small>
        </div>

        <div class="alert alert-light border d-flex align-items-center mb-3 py-2 px-3" style="font-size: 0.85rem; background-color: #f8f9fa;">
          <i class="pi pi-info-circle text-primary mr-2" style="font-size: 1.1rem;"></i>
          <span>
            As exportações são geradas em fila. Quando o status estiver <strong>Concluída</strong>, clique no botão de download. Para arquivos grandes, o download ocorre em segundo plano e você pode continuar utilizando o sistema normalmente.
          </span>
        </div>

        <div class="table-responsive">
          <DataTable :value="exportsList" :paginator="true" :rows="4"
            class="p-datatable-responsive p-datatable-sm" :autoLayout="true">
            <Column headerStyle="width: 5.5rem" bodyStyle="text-align: center" header="Download">
              <template #body="slotProps">
                <Button 
                  :disabled="slotProps.data.status !== 'Concluído' || loading || downloadingIds.includes(slotProps.data.id)" 
                  type="button" 
                  :icon="downloadingIds.includes(slotProps.data.id) ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                  class="p-button-sm p-button-success"
                  :title="downloadingIds.includes(slotProps.data.id) ? 'Transferência em andamento...' : 'Baixar arquivo exportado'"
                  @click="downloadExportacao(slotProps.data.id, slotProps.data.tipo, slotProps.data.dataInicial, slotProps.data.dataFinal)" >
                </Button>
              </template>
            </Column>
            <Column bodyStyle="text-align: center" field="dataSolicitacaoFormatada" header="Data Solicitação"></Column>
            <Column bodyStyle="text-align: center" field="periodoInicialFormatado" header="Período Inicial"></Column>
            <Column bodyStyle="text-align: center" field="periodoFinalFormatado" header="Período Final"></Column>
            <Column bodyStyle="text-align: center" field="tipoFormatado" header="Tipo Exportação"></Column>
            <Column bodyStyle="text-align: center" header="Tamanho">
              <template #body="slotProps">
                <span v-if="slotProps.data.tamanhoFormatado && slotProps.data.tamanhoFormatado !== '-'" class="badge badge-light border text-dark font-weight-bold">
                  <i class="pi pi-file mr-1 text-muted"></i>{{ slotProps.data.tamanhoFormatado }}
                </span>
                <span v-else class="text-muted">-</span>
              </template>
            </Column>
            <Column bodyStyle="text-align: center" header="Status">
              <template #body="slotProps">
                <span v-if="slotProps.data.status && slotProps.data.status.toLowerCase().startsWith('conclu')" class="badge badge-success bg-success text-white p-2">
                  <i class="pi pi-check mr-1"></i> Concluída
                </span>
                <span v-else-if="slotProps.data.status && slotProps.data.status.includes('Processando')" class="badge badge-primary bg-primary text-white p-2">
                  <i class="pi pi-spin pi-spinner mr-1"></i> Em Processamento
                </span>
                <span v-else-if="slotProps.data.status && slotProps.data.status.includes('Pendente')" class="badge badge-danger bg-danger text-white p-2">
                  <i class="pi pi-clock mr-1"></i> Pendente
                </span>
                <span v-else-if="slotProps.data.status === 'Sem Dados'" class="badge badge-secondary bg-secondary text-white p-2">
                  <i class="pi pi-info-circle mr-1"></i> Sem Dados
                </span>
                <span v-else class="badge badge-danger bg-danger text-white p-2">
                  <i class="pi pi-exclamation-triangle mr-1"></i> {{ slotProps.data.status }}
                </span>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>

      <div class="d-flex flex-wrap justify-content-between align-items-center pt-3 mt-2 border-top">
        <div class="d-flex flex-wrap align-items-center mb-2">
          <Button v-if="origem === 'NFSE'"
            @click="showExportarNfsePeriodo = false" 
            type="button" 
            label="Voltar"
            class="p-button-secondary mr-2 mb-1" 
            icon="pi pi-angle-left" 
          />

          <Button v-if="origem === 'DAPS'"
            @click="showExportarNfsePeriodo = false" 
            type="button" 
            label="Fechar"
            class="p-button-danger mr-2 mb-1" 
            icon="pi pi-times" 
          />

          <Button @click="solicitarExportacao('NORMAL')" href="#topo" type="button" label="Exportar Notas"
            class="p-button-success mr-2 mb-1" icon="pi pi-upload" :disabled="loading" />
        </div>

        <div v-if="admin && origem === 'NFSE'" class="mb-2">
          <div class="dropdown d-inline-block">
            <Button 
              class="p-button-info mr-2 mb-1" 
              type="button" 
              id="dropdownMenuAdmin" 
              icon="pi pi-cog" 
              label="Ações Administrativas" 
              data-toggle="dropdown" 
              aria-haspopup="true" 
              aria-expanded="false" 
              :disabled="loading"
            />
            <div class="dropdown-menu dropdown-menu-right shadow-sm" aria-labelledby="dropdownMenuAdmin">
              <button class="dropdown-item" type="button" :disabled="loading" @click="solicitarExportacao('A')">
                <span class="pi pi-file mr-2 text-primary"></span>Exportação Geral (Abrasf)
              </button>
              <button class="dropdown-item" type="button" :disabled="loading" @click="solicitarExportacao('Y')">
                <span class="pi pi-cloud-download mr-2 text-info"></span>Exportação Geral (Nota Nacional)
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </span>
</template>

<script>
import { maska } from 'maska'
import ContribuinteServicoService from "@/services/tributario/contribuinte.servico.service";
import NotaFiscalService from "@/services/nfse/notafiscal.service";
import PessoaService from "@/services/nfse/pessoa.service";
import LoginService from "@/services/acesso/login.service";
import ReportService from "@/services/report.service";
import CustomCalendar from "@/components/global/CustomCalendar.vue";

export default {
  directives: { maska },
  name: "ExportarNfseMaiorPeriodo",
  components: { CustomCalendar },
  props:{
    origem: {
      type: String,
      default: 'NFSE'
    }
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.notaAvulsa = this.currentUser.emiteNotaAvulsa;
    this.admin = this.currentUser.usuario.idBolAdmin;

    this.consultaSolicitacoes();

    this.$root.$on("notaFiscal:exportarMaiorPeriodo", () => {
      this.showExportarNfsePeriodo = true;
      this.dataFatoGeradorIni = null;
      this.dataFatoGeradorFim = null;
      this.selectedPessoa = null;
      this.filteredPessoas = null;
      this.selectedServico = null;
      this.filteredServicos = null;

      this.filtroTipo = this.tiposFiltrados[0];
      this.consultaSolicitacoes();
    });

  },
  watch: {
    showExportarNfsePeriodo(val) {
      if (val) {
        this.consultaSolicitacoes();
      } else {
        if (this.pollTimer) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
        }
      }
    }
  },

  data() {
    return {
      loading: false,
      showExportarNfsePeriodo: false,
      currentUser: null,
      dataFatoGeradorIni: null,
      dataFatoGeradorFim: null,
      selectedPessoa: null,
      filteredPessoas: null,
      selectedServico: null,
      filteredServicos: null,
      notaAvulsa: null,
      filtroSituacao: "",
      filtroSituacoes: [
        { name: "Todos", key: "T" },
        { name: "Ativa", key: "A" },
        { name: "Cancelada", key: "C" },
        { name: "Substituida", key: "S" }
      ],
      filtroTipo: "",
      filtroTipos: [
        { name: "XML", key: "X" },
        { name: "XLS", key: "E" },
        { name: "PDF", key: "P" }
      ],
      exportsList: [],
      admin: false,
      pollTimer: null,
      downloadingIds: []
    };
  },
  beforeDestroy() {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
      this.pollTimer = null;
    }
  },

  methods: {
    searchPessoa(event) {
      setTimeout(async () => {
        this.filteredPessoas = await PessoaService.findAllByConttribuinteFiltro(
          event.query,
          ""
        );
      }, 550);
    },
    searchServico(event) {
      if (this.currentUser.configuracao.idBolHabilitaCnaeNf == "N") {
        if (this.notaAvulsa) {
          // Se for nota avulsa exibir todos os serviços
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllNfAvulsa(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        } else {
          setTimeout(async () => {
            this.filteredServicos =
              await ContribuinteServicoService.findAllServicosByContribuinteFiltro(
                event.query,
                this.currentUser.contribuinte.idContribuinte
              );
          }, 250);
        }
      }
    },
    consultaSolicitacoes(silencioso = false) {
      if (!this.currentUser || !this.currentUser.contribuinte || !this.currentUser.contribuinte.idContribuinte) {
        return;
      }
      const idContribuinte = this.currentUser.contribuinte.idContribuinte;
      if (!silencioso) {
        this.processando(true);
      }
      const req = this.origem === 'DAPS'
        ? NotaFiscalService.findSolicitExportDaps(idContribuinte)
        : NotaFiscalService.findSolicitExportNfse(idContribuinte);

      req.then((data) => {
        this.exportsList = data.data ? [...data.data] : [];
        this.verificarStatusParaPolling();
      }).catch((err) => {
        console.error("Erro ao consultar solicitações:", err);
      }).finally(() => {
        if (!silencioso) {
          this.processando(false);
        }
      });
    },
    verificarStatusParaPolling() {
      if (!this.showExportarNfsePeriodo) {
        if (this.pollTimer) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
        }
        return;
      }
      const temPendentes = this.exportsList && this.exportsList.some(item =>
        item.status && (
          item.status.toLowerCase().includes('pendente') ||
          item.status.toLowerCase().includes('processando')
        )
      );
      if (temPendentes) {
        if (!this.pollTimer) {
          this.pollTimer = setInterval(() => {
            this.consultaSolicitacoes(true);
          }, 3000);
        }
      } else {
        if (this.pollTimer) {
          clearInterval(this.pollTimer);
          this.pollTimer = null;
        }
      }
    },
    solicitarExportacao(modo) {
      var msg = null;
      var isGeral = modo === 'A' || modo === 'Y' || modo === 'G';
      if (!this.currentUser.contribuinte.idContribuinte) {
        msg = "É necessário informar o contribuinte!";
      } else if (!this.dataFatoGeradorIni) {
        msg = "É necessário informar o Período Inicial!";
      } else if (!this.dataFatoGeradorFim) {
        msg = "É necessário informar o Período Final!";
      } else if (!this.filtroSituacao && !this.filtroSituacao.key) {
        msg = "É necessário informar uma Situação!";
      } else if (!isGeral && (!this.filtroTipo || !this.filtroTipo.key)) {
        msg = "É necessário informar o Tipo de Exportação!";
      }

      if (!msg) {
        const tipoEnvio = isGeral ? modo : this.filtroTipo.key;
        this.$toast.add({
          group: "bc",
          severity: "info",
          summary: "Exportação em Andamento",
          detail:
            "Sua solicitação foi registrada e será processada em segundo plano. Você pode acompanhar o status no Histórico de Solicitações abaixo.",
          life: 8000,
        });

        this.processando(true);
        NotaFiscalService.solicitarExportacoNfse(
          this.currentUser.contribuinte.idContribuinte,
          this.currentUser.usuario.idUsuario,
          this.dataFatoGeradorIni,
          this.dataFatoGeradorFim,
          (this.selectedPessoa && this.selectedPessoa.documento ? this.selectedPessoa.documento : ""),
          (this.selectedServico && this.selectedServico.idServico ? this.selectedServico.idServico.idServicoItem : ""),
          (this.filtroSituacao && this.filtroSituacao.key != "T" ? this.filtroSituacao.key : ""),
          tipoEnvio,
          (this.origem === "NFSE" ? "N" : "S")
        )
          .then(
            (data) => {
              this.$root.$emit("alert:success", "Solicitação de exportação registrada com sucesso!");
              console.log(data);
              this.consultaSolicitacoes();
            },
            (error) => {
              console.log(error);
            }
          )
          .then(() => {
            this.processando(false);
          });
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    downloadExportacao(idSolicitacao, tipo) {
      if (this.downloadingIds.includes(idSolicitacao)) {
        return;
      }
      this.downloadingIds.push(idSolicitacao);
      this.$toast.add({
        severity: "info",
        summary: "Iniciando Download",
        detail:
          "O download foi solicitado. Para arquivos grandes (centenas de MBs), o navegador pode levar alguns instantes para iniciar a transferência.",
        life: 7000,
      });
      if (tipo === "E" || tipo === "P" || tipo === "A" || tipo === "Y" || tipo === "G" || tipo === "N") {
        ReportService.downloadExportacoesZip(idSolicitacao);
      } else {
        ReportService.downloadExportacoesMaiorPer(idSolicitacao);
      }
      setTimeout(() => {
        this.downloadingIds = this.downloadingIds.filter(id => id !== idSolicitacao);
      }, 6000);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
  },

  computed: {
    tituloModel(){
      return this.origem === 'NFSE' ? 'Exportar Notas Fiscais' : 'Exportar Substituição';
    },
    tiposFiltrados() {
      if (this.origem === 'DAPS') {
        return this.filtroTipos.filter(t => t.key === 'X');
      }
      return this.filtroTipos;
    },
    placeholderPessoa() {
      return this.origem === 'DAPS'
        ? 'Pesquisar CPF/CNPJ/Nome Prestador'
        : 'Pesquisar CPF/CNPJ/Nome Tomador';
    }
  }
};
</script>

<style scoped>
.msg-export {
  margin-top: 10px;
  text-align: left;
}

.cursor-pointer {
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f1f5f9;
}
</style>